import { DESKTOP_MIN_WIDTH } from '@/components/blocks/PLPProductCard/constants';
import { SxProps, Theme } from '@mui/material';

export const catalogEntryListContainerSX: SxProps = {
	flex: 1,
	height: '100%',
	mt: { md: '20px' },
};

export const titleAndSortContainerSx: SxProps<Theme> = (theme) => ({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',

	[theme.breakpoints.down(DESKTOP_MIN_WIDTH - 1)]: {
		flexDirection: 'column',
		alignItems: 'flex-start',
	},
});
